import React from 'react';

import H from '@hero/ui-kit/typography/H';
import P from '@hero/ui-kit/typography/P';
import type { ClassificationDTO } from '@hero/hero-types';

import ClassificationRow from './ClassificationRow';
import * as styles from './style.module.css';

type Props = {
    classifications: ClassificationDTO[] | null | undefined;
};

const ClassificationsList: React.FC<Props> = ({ classifications }) => {
    const safe = Array.isArray(classifications) ? classifications : [];
    return (
        <div className={styles.section}>
            <H role="h5">{`Fired classifications (${safe.length})`}</H>
            {safe.length === 0 ? (
                <P>No detectors fired.</P>
            ) : (
                safe.map((c, idx) => (
                    <ClassificationRow
                        key={`${c?.pattern ?? 'unknown'}-${idx}`}
                        classification={c}
                    />
                ))
            )}
        </div>
    );
};

export default ClassificationsList;
